import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Jsonb from '@/utils/Jsonb'
import Vue from 'vue'

const state = {
  categoryName: '機能',

  // 選択機能名
  functionName: null,

  // サービスUUID
  serviceId: null,
  // コミュニティUUID
  communityId: null,

  // model
  deviceModel: [],
  noticeTypeMstModel: [],
  dictionaryModel: [],

  // form
  targetId: Constants.RegisterHash,
  dictionaryTargetId: Constants.RegisterHash,
  values: {},
  deliveryType: null,
  // 検索
  filters: {
    searchDeviceSerial: ''
  }
}

const getters = {
  get: state => state,

  // 登録値を表示用に変換
  getValue: state => (key) => {
    try {
      let value = state.values[key]
      switch (key) {
        default:
          return value
      }
    /* eslint-disable no-new */
    } catch (e) {
      return ''
    }
  },
  isRegister: state => state.dictionaryTargetId === Constants.RegisterHash,
}

const actions = {
  /**
   * 初期データを読出し
   */
  loadModel ({commit}, {functionParams}) {
    commit('setServiceId', functionParams.serviceUuid)
    commit('setTargetId', functionParams.serviceFunctionUuid)

    return new Promise((resolve, reject) => {
      ApiManager.request(
        ['serviceFunction'],
        ['v1ServiceFunctionDetailGet'],
        [functionParams])
        .then(res => {
          console.log('res', res[0].data)
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('setFunctionName', res[0].data.serviceFunctionName)

            // 見守り機能設定
            if (res[0].data.followSetting !== undefined) {
              commit('setDeliveryType', 'follow')
              commit('initFollowSetting', res[0].data.followSetting)
            }
            // 御用聞き機能設定
            if (res[0].data.ordertakeSetting !== undefined) {
              commit('setDeliveryType', 'ordertake')
              commit('initOrdertakeSetting', res[0].data.ordertakeSetting)
            }
            // スマホ連携機能設定
            if (res[0].data.familyInfoSetting !== undefined) {
              commit('setDeliveryType', 'family_info')
              commit('initFamilyInfoSetting', res[0].data.familyInfoSetting)
            }
            // 警戒レベル告知機能設定
            if (res[0].data.keikaiSetting !== undefined) {
              commit('setDeliveryType', 'keikai')
              commit('initKeikaiSetting', res[0].data.keikaiSetting)
            }

            // ささえiでんわ機能設定
            if (res[0].data.videoChatSetting !== undefined) {
              commit('setDeliveryType', 'video_chat')
              commit('initVideoChatSetting', res[0].data.videoChatSetting)
            }

            // カレンダー機能設定
            if (res[0].data.calendarSetting !== undefined) {
              commit('setDeliveryType', 'calendar')
              commit('initCalendarSetting', res[0].data.calendarSetting)
            }
            // アプリ起動ボタン設定
            if (res[0].data.appLaunchSetting !== undefined) {
              commit('setDeliveryType', 'app_launch')
              commit('initAppLaunchSetting', res[0].data.appLaunchSetting)
            }

            if (res[0].data.soundBroadcastSetting !== undefined){
              commit('setDeliveryType', 'sound_broadcast')
              commit('initSoundBroadcastSetting', res[0].data.soundBroadcastSetting)
            }

            commit('setCommunityId', res[0].data.communityUuid || null)
            commit('setInputFilter', {key:'searchDeviceSerial',value:''})

            console.log('values', state.values)
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },

  /**
   * デバイス一覧を読出し
   */
  loadDeviceList ({commit}, {deviceParams}) {
    return new Promise((resolve, reject) => {
      console.log('deviceParams', deviceParams)
      ApiManager.request(
        ['device'],
        ['v1DeviceListGet'],
        [deviceParams])
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('setDeviceModel', res[0].data.deviceTypes)
            console.log('deviceModel', state.deviceModel)
            resolve(res[0].data.deviceTypes)

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },

  loadNoticeTypeList ({commit},{Params}) {
    return new Promise((resolve, reject) => {
      ApiManager.request(
          ['noticeTypeMst'],
          ['v1NoticeTypeMstListGet'],
          [Params]
          )
          .then(res => {
            let status = Utility.parseResponse(res)
            if (status.result) {
              let noticeTypeMst = res[0].data.noticeTypeMsts
              noticeTypeMst = noticeTypeMst.filter(item => item.isText2speechEnabled)
              commit('setNoticeTypeMstModel', noticeTypeMst)
              resolve(res[0].data.noticeTypeMsts)
            } else if (status.error) {
              // エラーメッセージ表示
              reject(res)
            } else {
              // アプリケーションエラー表示
              reject(null)
            }
          })
          .catch(error => {
            // アプリケーションエラー表示
            reject(null)
          })
    })
  },

  initDictionary ({commit}) {
    commit('setDictionaryTargetId', Constants.RegisterHash)
    commit('initDictionary')
  },

  initModify ({commit}, {data}) {
    commit('setDictionaryTargetId', data.index)
    commit('initModify', data)
  },

  /**
   * リセット
   */
  reset ({commit}) {
    commit('reset')
  }
}

const mutations = {
  // function name
  setFunctionName (state, str) {
    state.functionName = str
  },

  // service uuid
  setServiceId (state, id) {
    state.serviceId = id
  },
  setCommunityId (state, id) {
    state.communityId = id
  },

  // model
  setDeviceModel (state, data) {
    // data.sort(Utility.sortByKey('CreatedAt', false))
    Vue.set(state, 'deviceModel', data)
  },

  // form
  setTargetId (state, targetId) {
    state.targetId = targetId
  },
  setValues (state, values) {
    Vue.set(state, 'values', values)
  },
  setInputValue (state, {key, value}) {
    Vue.set(state.values, key, value)
  },
  setDeliveryType (state, type) {
    Vue.set(state, 'deliveryType', type)
  },
  setNoticeTypeMstModel(state, data) {
    Vue.set(state, 'noticeTypeMstModel', data)
  },
  setDictionaryTargetId (state, targetId) {
    state.dictionaryTargetId = targetId
  },
  setInputFilter(state, { key, value }) {
    Vue.set(state.filters, key, value);
  },

  // form mode
  initFollowSetting (state, data) {
    // データ未登録の場合はjsonbフォーマットを作成
    if (data === null) {
      data = {
        jingleFile: null,
        soundMessageFile: null,
        enqueteMessage: null,
        enqueteAnswers: [
          Jsonb.createObject('EnqueteAnswer', 0),
          Jsonb.createObject('EnqueteAnswer', 1),
          Jsonb.createObject('EnqueteAnswer', 2),
          Jsonb.createObject('EnqueteAnswer', 3)
        ],
        // 202305 機能設定の「見守り機能」に「見守り未回答通知設定」を追加 ST
        messageAftAnswers: null,
        isNoReplyNotificationEnabled: true,
        isNoReplyMailNotification: true,
        isNoReplyBotNotification: true,
        isNoReplyDeviceNotification: false,
        minDaysNoReplyNotification: null,
        // 202305 機能設定の「見守り機能」に「見守り未回答通知設定」を追加 ED
        // 202402 機能設定の「見守り機能」に「見守り回答通知設定」を追加 ST
        isReplyNotificationEnabled: true,
        isReplyMailNotification: true,
        isReplyBotNotification: true,
        isReplyDeviceNotification: false
        // 202402 機能設定の「見守り機能」に「見守り回答通知設定」を追加 ED
      }
    }
    Vue.set(state, 'values', data)

    // input
    Vue.set(state.values, 'inpJingleFile', data.jingleFile || null)
    Vue.set(state.values, 'inpSoundMessageFile', data.soundMessageFile || null)
    Vue.set(state.values, 'inpEnqueteMessage', data.enqueteMessage || null)
    Vue.set(state.values, 'inpEnqueteAnswers', data.enqueteAnswers || [])
    Vue.set(state.values, 'inpMessageAftAnswers', data.messageAftAnswers || null)
    // 202305 機能設定の「見守り機能」に「見守り未回答通知設定」を追加 ST
    if (!data?.hasOwnProperty('isNoReplyNotificationEnabled')) {
      Vue.set(state.values, 'inpIsNoReplyNotificationEnabled', true)
      Vue.set(state.values, 'inpIsNoReplyMailNotification', true)
      Vue.set(state.values, 'inpIsNoReplyBotNotification', true)
      Vue.set(state.values, 'inpIsNoReplyDeviceNotification', false);
    } else {
      Vue.set(state.values, 'inpIsNoReplyNotificationEnabled', data.isNoReplyNotificationEnabled)
      if (
        !data?.hasOwnProperty('isNoReplyBotNotification') &&
        !data?.hasOwnProperty('isNoReplyMailNotification') &&
        !data?.hasOwnProperty('isNoReplyDeviceNotification')
      ) {
        if (data.isNoReplyNotificationEnabled === true) {
          Vue.set(state.values, 'inpIsNoReplyMailNotification', true)
          Vue.set(state.values, 'inpIsNoReplyBotNotification', true)
          Vue.set(state.values, 'inpIsNoReplyDeviceNotification', false)
        } else {
          Vue.set(state.values, 'inpIsNoReplyMailNotification', false)
          Vue.set(state.values, 'inpIsNoReplyBotNotification', false)
          Vue.set(state.values, 'inpIsNoReplyDeviceNotification', false)
        }
      } else {
        Vue.set(state.values, 'inpIsNoReplyMailNotification', data.isNoReplyMailNotification)
        Vue.set(state.values, 'inpIsNoReplyBotNotification', data.isNoReplyBotNotification)
        Vue.set(
          state.values,
          "inpIsNoReplyDeviceNotification",
          data.isNoReplyDeviceNotification
        );
      }
    }
    Vue.set(state.values, 'inpMinDaysNoReplyNotification', data.minDaysNoReplyNotification || null)
    // 202305 機能設定の「見守り機能」に「見守り未回答通知設定」を追加 ED
    // 202402 機能設定の「見守り機能」に「見守り回答通知設定」を追加 ST
    if (!data?.hasOwnProperty('isReplyNotificationEnabled')) {
      Vue.set(state.values, 'inpIsReplyNotificationEnabled', true)
      Vue.set(state.values, 'inpIsReplyMailNotification', true)
      Vue.set(state.values, 'inpIsReplyBotNotification', true)
      Vue.set(state.values, 'inpIsReplyDeviceNotification', false)
    } else {
      Vue.set(state.values, 'inpIsReplyNotificationEnabled', data.isReplyNotificationEnabled)
      Vue.set(state.values, 'inpIsReplyMailNotification', data.isReplyMailNotification)
      Vue.set(state.values, 'inpIsReplyBotNotification', data.isReplyBotNotification)
      Vue.set(
        state.values,
        'inpIsReplyDeviceNotification',
        data.isReplyDeviceNotification
      )
    }
    // 202402 機能設定の「見守り機能」に「見守り回答通知設定」を追加 ED
  },
  initOrdertakeSetting (state, data) {
    // データ未登録の場合はjsonbフォーマットを作成
    if (data === null) {
      data = {
        jingleFile: null,
        serviceName: null,
        ordertakeGuideMessage: null,
        ordertakeGuideSound: null,
        ordertakeBtns: [],
        // ordertakeBtns: [
        //   Jsonb.createObject('OrdertakeBtn', 0),
        //   Jsonb.createObject('OrdertakeBtn', 1),
        //   Jsonb.createObject('OrdertakeBtn', 2),
        // ],
        ordertakeRequestAcceptionMessage: null,
        ordertakeRequestAcceptionSound: null,
        ordertakeAcceptionCancelMessage: null,
        ordertakeAcceptionCancelSound: null,
        ordertakeRequestCancelMessage: null,
        ordertakeRequestCancelSound: null,
      }
    }
    Vue.set(state, 'values', data)

    // input
    Vue.set(state.values, 'inpJingleFile', data.jingleFile || null)
    Vue.set(state.values, 'inpServiceName', data.serviceName || null)
    Vue.set(state.values, 'inpOvertakeGuideMessage', data.ordertakeGuideMessage || null)
    Vue.set(state.values, 'inpOvertakeGuideSound', data.ordertakeGuideSound || null)
    Vue.set(state.values, 'inpOvertakeBtns', data.ordertakeBtns || [])
    Vue.set(state.values, 'inpOvertakeRequestAcceptionMessage', data.ordertakeRequestAcceptionMessage || null)
    Vue.set(state.values, 'inpOvertakeRequestAcceptionSound', data.ordertakeRequestAcceptionSound || null)
    Vue.set(state.values, 'inpOvertakeAcceptionCancelMessage', data.ordertakeAcceptionCancelMessage || null)
    Vue.set(state.values, 'inpOvertakeAcceptionCancelSound', data.ordertakeAcceptionCancelSound || null)
    Vue.set(state.values, 'inpOvertakeRequestCancelMessage', data.ordertakeRequestCancelMessage || null)
    Vue.set(state.values, 'inpOvertakeRequestCancelSound', data.ordertakeRequestCancelSound || null)
  },
  initFamilyInfoSetting (state, data) {
    // データ未登録の場合はjsonbフォーマットを作成
    if (data === null) {
      data = {
        areaCode: null,
        maxLinkedSPCount: 0,
        serviceName: null,
        serviceProtocol: null,
        loadingAnimationFile: null,
        mainVisualFile: null,
        subVisualFile: null,
        contact: null,
        departmentInCharge: null,
        copyRight: null,
        phoneNumber: null,
        recommededLinkUrls: []
      }
    }
    Vue.set(state, 'values', data)

    // input
    Vue.set(state.values, 'inpAreaCode', data.areaCode || null)
    Vue.set(state.values, 'inpMaxLinkedSPCount', data.maxLinkedSPCount)
    Vue.set(state.values, 'inpServiceName', data.serviceName || null)
    Vue.set(state.values, 'inpServiceProtocol', data.serviceProtocol || null)
    Vue.set(state.values, 'inpLoadingAnimationFile', data.loadingAnimationFile || null)
    Vue.set(state.values, 'inpMainVisualFile', data.mainVisualFile || null)
    Vue.set(state.values, 'inpSubVisualFile', data.subVisualFile || null)
    Vue.set(state.values, 'inpContact', data.contact || null)
    Vue.set(state.values, 'inpDepartmentInCharge', data.departmentInCharge || null)
    Vue.set(state.values, 'inpCopyRight', data.copyRight || null)
    Vue.set(state.values, 'inpPhoneNumber', data.phoneNumber || null)
    Vue.set(state.values, 'inpRecommededLinkUrls', data.recommededLinkUrls || [])
  },
  initKeikaiSetting (state, data) {
    // データ未登録の場合はjsonbフォーマットを作成
    if (data === null) {
      data = {
        keikaiJingleFile: null,
        keikaiSoundFile: null,
        keikaiLevel0TextMain: null,
        keikaiLevel0TextSub: null,
        keikaiLevel1TextMain: null,
        keikaiLevel1TextSub: null,
        keikaiLevel2TextMain: null,
        keikaiLevel2TextSub: null,
        keikaiLevel3TextMain: null,
        keikaiLevel3TextSub: null,
        keikaiLevel4TextMain: null,
        keikaiLevel4TextSub: null,
        keikaiLevel5TextMain: null,
        keikaiLevel5TextSub: null,
        noteText: null,
      }
    }
    Vue.set(state, 'values', data)

    // input
    Vue.set(state.values, 'inpKeikaiJingleFile', data.keikaiJingleFile || null)
    Vue.set(state.values, 'inpKeikaiSoundFile', data.keikaiSoundFile || null)
    Vue.set(state.values, 'inpKeikaiLevel0TextMain', data.keikaiLevel0TextMain || null)
    Vue.set(state.values, 'inpKeikaiLevel0TextSub', data.keikaiLevel0TextSub || null)
    Vue.set(state.values, 'inpKeikaiLevel1TextMain', data.keikaiLevel1TextMain || null)
    Vue.set(state.values, 'inpKeikaiLevel1TextSub', data.keikaiLevel1TextSub || null)
    Vue.set(state.values, 'inpKeikaiLevel2TextMain', data.keikaiLevel2TextMain || null)
    Vue.set(state.values, 'inpKeikaiLevel2TextSub', data.keikaiLevel2TextSub || null)
    Vue.set(state.values, 'inpKeikaiLevel3TextMain', data.keikaiLevel3TextMain || null)
    Vue.set(state.values, 'inpKeikaiLevel3TextSub', data.keikaiLevel3TextSub || null)
    Vue.set(state.values, 'inpKeikaiLevel4TextMain', data.keikaiLevel4TextMain || null)
    Vue.set(state.values, 'inpKeikaiLevel4TextSub', data.keikaiLevel4TextSub || null)
    Vue.set(state.values, 'inpKeikaiLevel5TextMain', data.keikaiLevel5TextMain || null)
    Vue.set(state.values, 'inpKeikaiLevel5TextSub', data.keikaiLevel5TextSub || null)
    Vue.set(state.values, 'inpNoteText', data.noteText || null)
  },
  initVideoChatSetting (state, data) {
    // データ未登録の場合はjsonbフォーマットを作成
    if (data === null) {
      data = {}
    }
    Vue.set(state.values, 'videoChatSetting', data)

    // input
    // ビデオチャット機能設定:デバイスタイプUUID
    Vue.set(state.values, 'inpDeviceTypeUuids', data.deviceTypeUuids || [])
    // 連携CMSでささえiでんわタブ表示設定
    Vue.set(state.values, 'inpIsVideoChatCmsLogDownloadTabVisible', data.isVideoChatCmsLogDownloadTabVisible || false)
    // お気に入り表示デバイスタイプUUID
    Vue.set(state.values, 'inpFavoritesVisibleDeviceTypeUuids', data.favoritesVisibleDeviceTypeUuids || null)
    // スマホアプリにてお気に入り表示有無
    Vue.set(state.values, 'inpIsFavoritesVisibleOnSPApp', data.isFavoritesVisibleOnSPApp === undefined ? true : data.isFavoritesVisibleOnSPApp)
    // ビデオチャットのアドレス帳ボタン表示設定
    Vue.set(state.values, 'inpIsAddressBookButtonVisibleOnDevice', data.isAddressBookButtonVisibleOnDevice === undefined ? true : data.isAddressBookButtonVisibleOnDevice)
    // ビデオチャットのニックネーム検索機能設定
    Vue.set(state.values, 'inpIsNickNameSearchButtonVisibleOnDevice', data.isNickNameSearchButtonVisibleOnDevice === undefined ? true : data.isNickNameSearchButtonVisibleOnDevice)
    // ビデオ電話のカメラON・OFF設定, ON: true(default), OFF: false
    Vue.set(state.values, 'inpIsVideoCallCameraEnabled', data.isVideoCallCameraEnabled)
    // ビデオ電話のカメラ強制OFF設定, 強制OFF状態: true, 非強制OFF状態: false (default) 
    Vue.set(state.values, 'inpIsVideoCallCameraForcedOff', data.isVideoCallCameraForcedOff)
    // ビデオ電話の通話音量設定, ユーザ設定：0(default)、最大音量：1
    Vue.set(state.values, 'inpVideoCallVolume', data.videoCallVolume)
    // 声かけ電話のカメラON・OFF設定, ON：true, OFF: false(default)
    Vue.set(state.values, 'inpIsAutoAnswerCallCameraEnabled', data.isAutoAnswerCallCameraEnabled ? 1 : (data.isAutoAnswerCallCameraForcedOff ? 3 : 2))
    // 声かけ電話のカメラ強制OFF設定, 強制OFF状態: true, 非強制OFF状態: false (default)
    Vue.set(state.values, 'inpIsAutoAnswerCallCameraForcedOff', data.isAutoAnswerCallCameraForcedOff)
    // 声かけ電話の通話音量設定, ユーザ設定：0、最大音量：1(default)
    Vue.set(state.values, 'inpAutoAnswerCallVolume', data.autoAnswerCallVolume)
    // 声かけ電話自動終了時間(秒)の設定, なし：-1、あり：300−6000(default:-1)
    Vue.set(state.values, 'inpAutoAnswerCallAutoEndTimeRadio', data.autoAnswerCallAutoEndTime === -1 ? 0 : 1)
    Vue.set(state.values, 'inpAutoAnswerCallAutoEndTime', data.autoAnswerCallAutoEndTime === -1 ? 600 : data.autoAnswerCallAutoEndTime)
    // ビデオ電話自動終了時間(秒)の設定, なし：-1、あり：300−6000(default:600)
    Vue.set(state.values, 'inpVideoCallAutoEndTimeRadio', data.videoCallAutoEndTime === -1 ? 0 : 1)
    Vue.set(state.values, 'inpVideoCallAutoEndTime', data.videoCallAutoEndTime === -1 ? 600 : data.videoCallAutoEndTime)
  },
  initIsVideoChatCmsLogDownloadTabVisible (state, data) {
    Vue.set(state.values, 'inpIsVideoChatCmsLogDownloadTabVisible', data)
  },
  initFavoritesVisibleDeviceTypeUuids (state, data) {
    Vue.set(state.values, 'inpFavoritesVisibleDeviceTypeUuids', data)
  },
  initIsFavoritesVisibleOnSPApp (state, data) {
    Vue.set(state.values, 'inpIsFavoritesVisibleOnSPApp', data)
  },
  initCalendarSetting (state, data) {
    // データ未登録の場合はjsonbフォーマットを作成
    if (data === null) {
      data = {
        eventsCalendarFlg: 1,
        garbageDaysCalendarFlg: 1,
      }
    }
    Vue.set(state.values, 'calendarSetting', data)

    // input
    Vue.set(state.values, 'inpCalendarEvent', data.eventsCalendarFlg === 1)
    Vue.set(state.values, 'inpCalendarGarbage', data.garbageDaysCalendarFlg === 1)
  },
  initAppLaunchSetting (state, data) {
    // データ未登録の場合はjsonbフォーマットを作成
    if (data === null) {
      data = []
    }
    Vue.set(state.values, 'appLaunchSetting', data)

    // input
    Vue.set(state.values, 'inpApps', data)
  },
  initSoundBroadcastSetting (state, data) {
    // データ未登録の場合はjsonbフォーマットを作成
    if (data === null) {
      data = {}
    }
    // input
    Vue.set(state.values, 'soundBroadcastSetting', data)
    Vue.set(state.values, 'inpNoticeTypes', data?.hasOwnProperty('noticeTypes') ? data.noticeTypes : [])
    Vue.set(state.values, 'dictionaryModel', data?.hasOwnProperty('dictionary') ? data.dictionary : [])
    Vue.set(state.values, 'inpWord', '')
    Vue.set(state.values, 'inpRuby', '')
  },
  initDictionary (state) {
    Vue.set(state.values, 'inpWord', '')
    Vue.set(state.values, 'inpRuby', '')
  },
  initModify (state, data) {
    Vue.set(state.values, 'inpWord', data.word)
    Vue.set(state.values, 'inpRuby', data.ruby)
  },

  // reset
  reset (state) {
    state.targetId = Constants.RegisterHash
    state.dictionaryTargetId = Constants.RegisterHash
    state.serviceId = null
    Vue.set(state, 'values', {})
    state.deliveryType = null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
